import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { MenuController, Platform, ToastController } from '@ionic/angular';

import { StatusBar } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

import { Storage } from '@ionic/storage';

import { AuthService } from 'ng2-ui-auth';

import { UserData } from './providers/user-data';
import { Events } from './providers/events';
import { WebsocketProvider } from './providers/websocket';
import { HandleRequest } from './providers/handleRequest';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  appPages = [
    {
      title: 'Schedule',
      url: '/app/tabs/schedule',
      icon: 'calendar'
    },
    {
      title: 'Contacts',
      url: '/app/tabs/contacts',
      icon: 'people'
    },
    {
      title: 'Chat',
      url: '/app/tabs/chat',
      icon: 'chatbubbles'
    },
    {
      title: 'Map',
      url: '/app/tabs/map',
      icon: 'map'
    },
    {
      title: 'About',
      url: '/app/tabs/about',
      icon: 'information-circle'
    }
  ];
  loggedIn = false;
  dark = false;
  header_title:string = "";
  username:string = ""
  credit:string;
  constructor(
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    private storage: Storage,
    private userData: UserData,
    private swUpdate: SwUpdate,
    private toastCtrl: ToastController,
    private events: Events,
    private auth: AuthService,
    private ws: WebsocketProvider,
    private handleRequest: HandleRequest
  ) {
    this.initializeApp();

    // this.events.subscribe("user-update",()=>{
    //   this.setUserData()
    // })
  }

  async ngOnInit() {
    this.checkLoginStatus();
    this.listenForLoginEvents();

    this.swUpdate.versionUpdates.subscribe(async res => {//available.subscribe(async res => {
      const toast = await this.toastCtrl.create({
        message: 'Update available!',
        position: 'bottom',
        buttons: [
          {
            role: 'cancel',
            text: 'Reload'
          }
        ]
      });

      await toast.present();

      toast
        .onDidDismiss()
        .then(() => this.swUpdate.activateUpdate())
        .then(() => window.location.reload());
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('hybrid')) {
        StatusBar.hide();
        SplashScreen.hide();
      }
    });
  }
 
  checkLoginStatus() {
    return this.userData.isLoggedIn().then(loggedIn => {
      this.initWebSocket();
      return this.updateLoggedInStatus(loggedIn);
    });
  }

  updateLoggedInStatus(loggedIn: boolean) {
    setTimeout(() => {
      this.loggedIn = loggedIn;
    }, 300);
  }

  listenForLoginEvents() {
    console.log("listenForLoginEvents")
    this.events.subscribe("app-login",()=>{
      console.log("listenForLoginEvents LOGIN-APP")
      this.initWebSocket()
    });
    this.events.subscribe("app-logout",()=>{
      console.log("listenForLoginEvents LOGOUT-APP")
      this.logout()
    })
    // window.addEventListener('user:login', () => {
    //   this.updateLoggedInStatus(true);
    // });

    // window.addEventListener('user:signup', () => {
    //   this.updateLoggedInStatus(true);
    // });

    // window.addEventListener('user:logout', () => {
    //   this.updateLoggedInStatus(false);
    // });
  }

  logout() {
    this.auth.logout()
      .subscribe({
        error: (err: any) => console.log(err),
        complete: () => {
          // this.authStatus.logout();
          this.destroyWebSocket();
          // this.phoneSvc.unregister();
          // this.nav.setRoot("page-login");
          return this.router.navigateByUrl('/login');
        }
      });
    // this.userData.logout().then(() => {
      
    // });
  }
  setHeader(){
    let path = this.router.url.split('/');
    if(path.indexOf('login')>-1){
      this.header_title = "Login"
    }else{
      let title = decodeURIComponent(path[2]);
      this.header_title = title.charAt(0).toUpperCase() + title.slice(1);
    }
    
  }
  openTutorial() {
    this.menu.enable(false);
    this.storage.set('ion_did_tutorial', false);
    this.router.navigateByUrl('/tutorial');
  }
  destroyWebSocket() {
    this.ws.leave('notifications');
    this.ws.close();
  }
  initWebSocket() {
    // const collectionMutex = new Mutex();
    this.handleRequest.wsStatus()
      .then((v) => {
        console.log("[success connecting to websocket]");
        this.ws.connect();
        this.ws.join('notifications', { user_uuid: this.userData.getUsername() });

        this.ws.getChannel('notifications').received()
          .subscribe(notification => {
            console.log("received", notification)
            if (notification.type == "ping") {
              console.warn("ping",notification.message);
            }
            if (notification.type == "join") {
              console.warn("join",notification);
              this.events.publish("app:call:event", {
                message: notification,
              });
            }
            if (notification.type == "failed") {
              console.error(notification.message);
              this.handleRequest.handleErrors({ message: notification.message }, 999);
            }
            if (notification.type == "success") {
              console.log(notification.message);
              this.events.publish("app:notifications:success", {
                message: notification.message,
              });
            }
          });
      })
      .catch((v) => {
        this.handleRequest.handleErrors({ message: "error connecting to service" }, 500);
      });
  }
}
